<template>
  <div class="ma-4 px-4">
    <searchBarFilter
      @add="create"
      @updateSearch="(v) => (search = v)"
      @updateBatch="(v) => ((searchBatch = v), (search = v))"
      @updateYear="(v) => ((searchYear = v), (search = v))"
      :showFilter="true"
      @fileUploaded="initialise"
    />
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="programPartnerSchedules"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
            :items-per-page="viewPartner ? itemsPerPage : 10"
            :hide-default-footer="viewPartner"
          >
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.program_id`]="{ value }">
              {{ getProgram(value) }}
            </template>
            <template #[`item.start_date`]="{ value }">
              {{ formatDate(value) }}
            </template>
            <template #[`item.course_start_date`]="{ value }">
              {{ formatDate(value) }}
            </template>
            <template #[`item.admission_end_date`]="{ value }">
              {{ formatDate(value) }}
            </template>
            <template #[`item.pre_app_fee`]="{ value }">
              ₹{{ value }}
            </template>
            <template #[`item.loan_allowed`]="{ value }">
              {{ value ? "Yes" : "No" }}
            </template>
            <template #[`item.partner_id`]="{ value }">
              <span
                :class="{
                  'accent--text': !viewPartner,
                }"
                :style="{
                  textDecoration: !viewPartner ? 'underline' : 'none',
                  cursor: !viewPartner ? 'pointer' : 'auto',
                }"
                @click="!viewPartner ? goToPartnerView(value) : ''"
              >
                {{ getPartner(value) }}
              </span>
            </template>
            <template #[`item.end_date`]="{ value }">
              {{ formatDate(value) }}
            </template>
            <template
              v-if="
                viewPartner &&
                programPartnerSchedules.length > 5 &&
                itemsPerPage > 0
              "
              v-slot:footer
            >
              <div class="d-flex text--accent justify-end mx-3 pa-3">
                <span
                  @click="navigate()"
                  style="
                    cursor: pointer;
                    color: #4f4584;
                    text-decoration: underline;
                  "
                  >View More</span
                >
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="850" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createProgramPartnerSchedule"
        @update="updateProgramPartnerSchedule"
        :data="data"
        :partners="partners"
        :edit="editMode"
        :viewPartner="viewPartner"
      />
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/programParnerSchedule/form.vue";
import searchBarFilter from "@/components/searchBarFilter.vue";
import { partnerProgramHeaders } from "@/constants/headers";

export default {
  components: {
    formDialog,
    searchBarFilter,
  },
  props: {
    partnerId: {
      type: Number,
      default: () => 0,
    },
    itemsPerPage: {
      type: Number,
      default: () => 0,
    },
    partners: {
      type: Array,
      default: () => [],
    },
    programs: {
      type: Array,
      default: () => [],
    },
    programPartnerSchedules: {
      type: Array,
      default: () => [],
    },
    viewPartner: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      data: {},
      currentItem: {},
      search: "",
      searchBatch: null,
      searchYear: null,
      headers: partnerProgramHeaders,
    };
  },
  watch: {},
  computed: {},
  created() {
    if (this.viewPartner)
      this.headers = this.headers.filter((item) => item.value !== "partner_id");
  },
  methods: {
    goToPartnerView(id) {
      this.$router.push({ name: "View Partner Add-on Programme", params: { id } });
    },
    async initialise() {
      this.$emit("getPrgPartnerSchedule");
    },
    navigate() {
      this.$emit("viewMore", "Partner");
    },
    async createProgramPartnerSchedule(data) {
      await this.$axios
        .post("batch_partner_schedules", { batch_partner_schedule: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Partner created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateProgramPartnerSchedule(data) {
      await this.$axios
        .put("batch_partner_schedules/" + data.id, {
          batch_partner_schedule: data,
        })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Partner updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    create() {
      this.data = { partner_id: this.partnerId };
      this.editMode = false;
      this.dialog = true;
    },
    edit(item) {
      this.data = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.data = {};
    },
    getProgram(id) {
      return this.programs.find((program) => program.id == id)?.degree
        ?.short_name;
    },

    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getPartner(value) {
      return this.partners.find((partner) => partner.id == value)?.name;
    },
    customFilter(value, search, item) {
      const formattedStartDate = this.formatDate(item.start_date);
      const formattedEndDate = this.formatDate(item.end_date);
      const formattedCourseStartDate = this.formatDate(item.course_start_date);
      const programName = this.getProgram(item.program_id);
      const partnerName = this.getPartner(item.partner_id);

      const textMatch =
        search === "" ||
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        formattedStartDate.includes(search) ||
        formattedEndDate.includes(search) ||
        formattedCourseStartDate.includes(search) ||
        programName.toLowerCase().includes(search.toLowerCase());
      partnerName.toLowerCase().includes(search.toLowerCase());

      const yearMatch =
        !this.searchYear || String(item.year) === String(this.searchYear);

      const batchMatch =
        !this.searchBatch ||
        String(item.batch).toLowerCase() === this.searchBatch.toLowerCase();

      return textMatch && yearMatch && batchMatch;
    },
  },
};
</script>

<style></style>
